import { useState, useEffect, useCallback } from 'react'
import {
  obtenerProductos,
  buscarProductos,
  guardarProducto,
  eliminarProducto,
  cargarDatosDemoSiVacio,
} from '../db/productos'
import { productosDB } from '../db/index'

export function useProductos() {
  const [productos, setProductos] = useState([])
  const [cargando, setCargando] = useState(true)

  const cargar = useCallback(async (termino = '') => {
    try {
      const lista = termino ? await buscarProductos(termino) : await obtenerProductos()
      setProductos(lista)
    } catch {
      // DB error — componente muestra estado vacío
    } finally {
      setCargando(false)
    }
  }, [])

  useEffect(() => {
    cargarDatosDemoSiVacio().then(() => cargar())
  }, [cargar])

  // Recargar cuando el sync trae cambios externos (no locales)
  useEffect(() => {
    const changes = productosDB.changes({ since: 'now', live: true })
      .on('change', () => cargar())
    return () => changes.cancel()
  }, [cargar])

  const guardar = useCallback(async (producto) => {
    await guardarProducto(producto)
    await cargar()
  }, [cargar])

  const eliminar = useCallback(async (producto) => {
    await eliminarProducto(producto)
    await cargar()
  }, [cargar])

  return { productos, cargando, cargar, guardar, eliminar }
}
